<!--
 * @Author: your name
 * @Date: 2021-03-12 13:35:58
 * @LastEditTime: 2021-08-09 16:14:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\components\swiper.vue
-->
<template>
  <div class="container-swiper">
    <swiper
      :options="swiperOptions"
      class="swiper-container swiper-pagination1"
      ref="mySwiper"
    >
      <!-- 添加的图片,src中存放图片路径 -->
      <swiper-slide v-for="(item, Index) in productList" :key="Index">
        <!-- <img class="banner-img auto-img" :src="item.imageUrl" /> -->
        <div class="swiper_item">
          <div class="item">
            <div class="img">
              <div 
                 v-if="item.productCategoryImgList &&item.productCategoryImgList.length > 0"
                class="bg_img series-img"
                :style="{backgroundImage:'url('+item.productCategoryImgList[0].imageUrl+')'}"
                 :data-id="item.id"
                :data-index="Index"
                :data-item="JSON.stringify(item)">
              </div>
              <!-- <img
                v-if="
                  item.productCategoryImgList &&
                  item.productCategoryImgList.length > 0
                "
                class="auto-img series-img"
                :src="item.productCategoryImgList[0].imageUrl"
                 :data-id="item.id"
                :data-index="Index"
                :data-item="JSON.stringify(item)"
              /> -->
            </div>
            <!-- <div class="right_item">
              <div class="title">{{ item.title }}</div>
              <div class="vice_title">{{ item.displayTitle }}</div>
              <div class="content">
                {{ item.description }}
              </div>
              <div
                class="more_btn"
                :data-id="item.id"
                :data-index="Index"
                :data-item="JSON.stringify(item)"
              >
                {{ lange == "Ch" ? "探索更多" : "もっと探して" }}
              </div>
            </div> -->
          </div>
        </div>
      </swiper-slide>
      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
    <div
      class="swiper-button-prev-sreies layout_vertica_center web"
      slot="button-prev"
    >
      <i class="el-icon-arrow-left" style="font-weight: bold !important"></i>
    </div>
    <div
      class="swiper-button-next-sreies layout_vertica_center web"
      slot="button-next"
    >
      <i class="el-icon-arrow-right" style="font-weight: bold !important"></i>
    </div>
  </div>
</template>

<script>
//局部引入swiper插件
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Vue from "vue";
export default {
  name: "SeriesCarousel",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ["productList"],
  // 定义属性
  data() {
    return {
      swiperOptions: {
        // 参数选项,显示小点
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observer: true,
        // 箭头配置
        navigation: {
          nextEl: ".swiper-button-next-sreies",
          prevEl: ".swiper-button-prev-sreies",
        },
        //循环
        loop: true,
        // autoplay: {
        //   disableOnInteraction: true,
        //   delay: 6000,
        // },
        //自动播放的相关设置
        on: {
          slideChangeTransitionStart: (e) => {
            this.activeIndex = e.activeIndex - 1;
          },
          click: (e) => {
            if (document.querySelectorAll(".series-img")[e.clickedIndex]) {
              const id = document
                .querySelectorAll(".series-img")
                [e.clickedIndex].getAttribute("data-id");
              const item = document
                .querySelectorAll(".series-img")
                [e.clickedIndex].getAttribute("data-item");
              const index = document
                .querySelectorAll(".series-img")
                [e.clickedIndex].getAttribute("data-index");
              this.onProductPage(id, item, index);
            }
          },
        },
      },
      activeIndex: 0,
    };
  },
  computed: {},
  // 监控data中的数据变化
  watch: {
    productList(val) {
      // if (val && val.length <= 1) this.swiperOption.loop = false;
    },
  },
  // 方法集合
  methods: {
    onProductPage(id, item, index) {
      this.$router.push({
        name: "Product",
        query: {
          id: id,
          detail: item,
          index: `1-${index}`,
        },
      });
    },
  },

  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>

<style lang='less' scoped>
.container-swiper {
  max-width: 1440px;
  min-width: 1240px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;

  .swiper-container {
    width: calc(100% - 100px);
    margin: 0px auto;
    position: relative;
    // padding-top: 80px;
     .swiper_item{
      cursor: pointer;
    }
    /deep/.swiper {
      // &-wrapper {
      //   margin: 0 50px;
      //   width: calc(100% - 100px) !important;
      // }
      &-pagination {
        width: 100%;
        height: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        z-index: 1;

        &-bullet {
          background: #fff !important;
          opacity: 1;
          margin: 0 5px;
        }
        &-bullet-active {
          background: #876d4b !important;
        }
        .my-bullet {
          border-radius: 50%;
          width: 4px;
          height: 4px;
          margin: 4px;
          background: #000000;
          display: block;
        }
        .my-bullet-active {
          display: block;
          background: #000000;
          width: 10px;
          height: 4px;
          border-radius: 2px;
        }
      }
      &-pagination-bullet {
        width: 230px;
        height: 10px;
        margin: 0 5px;
        background: #d9d9d9 !important;
        &-active {
          background: #876d4b !important;
        }
      }

      &_item {
        display: flex;
        justify-content: space-between;
        height: 500px;
        .item {
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          display: flex;
          width: 100%;
          justify-content: space-between;
          .img {
            width: 100%;
            height: 500px;
            overflow: hidden;
            padding-left: 1px;
          }
          .bg_img{width: 100%;height: 100%;}

          
          .right_item {
            width: calc(100% - 800px);
            text-align: center;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            .title {
              font-size: 28px;
              font-weight: bold;
              color: #212121;
              margin-top: 80px;
              display: inline-block;
              padding-bottom: 5px;
              border-bottom: 2px solid #876d4b;
            }
            .vice_title {
              font-size: 18px;
              font-weight: 400;
              color: #666666;
              margin: 21px auto 39px;
            }
            .content {
              max-width: 400px;
              font-size: 20px;
              font-weight: 300;
              color: #212121;
              text-align: left;
              margin: 0 auto 50px;
            }
            .more_btn {
              display: none;
              // width: 200px;
              // height: 64px;
              // background: #fffdf7;
              // border: 1px solid #876d4b;
              // margin: 0 auto;
              // text-align: center;
              // line-height: 64px;
              // font-size: 18px;
              // font-weight: 400;
              // color: #876d4b;
              // cursor: pointer;
            }
          }
        }
      }
    }
  }
  .swiper-button {
    &-prev-sreies {
      left: 0px;
    }
    &-next-sreies {
      right: 0px;
    }
    &-prev-sreies,
    &-next-sreies {
      width: 36px;
      height: 36px;
      border: 2px solid #212121;
      border-radius: 50%;
      z-index: 1;
      cursor: pointer;
      text-align: center;
      line-height: 36px;
      font-size: 24px !important;
      color: #212121;

      // display: none;
    }
  }
}
</style>
